import Page from './Page.js';
import { Link } from 'react-router-dom';
import FeaturedResources from './resources/FeaturedResources';
import FeaturedGuidebooks from './guidebooks/FeaturedGuidebooks';
import Search from './search/Search.js';
import InnerContent from './InnerContent.js';

let Home = () => {
  return (
    <Page>
      <div id="shelter-library-search-and-guidebooks" className="my-6">
        <Search />
        <InnerContent id={'shelter-library-viewer-inner-content'} />
        <div className="flex items-end space-x-4">
          <h2 className="text-left m-0 leading-none">Guidebooks</h2>
          <Link className="" to="/library/guidebooks">
            <span>View All Guidebooks</span>
          </Link>
        </div>
        <FeaturedGuidebooks />
      </div>
      <FeaturedResources />
    </Page>
  );
};

export default Home;
